module.exports = __webpack_public_path__ + "img/Ab3.4968b195.png";